var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-page-container',[(_vm.isShowDisplay)?_c('div',{staticStyle:{"position":"relative"}},[[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath,attrs:{"language":"en"}})],1)]],2):_c('initial-loader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }